import { render, staticRenderFns } from "./DefaultWrapper.vue?vue&type=template&id=9f0c2f36&scoped=true&"
import script from "./DefaultWrapper.vue?vue&type=script&lang=js&"
export * from "./DefaultWrapper.vue?vue&type=script&lang=js&"
import style0 from "./DefaultWrapper.vue?vue&type=style&index=0&id=9f0c2f36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f0c2f36",
  null
  
)

export default component.exports